










































import Vue from 'vue';
import { ZenFormGroup } from 'zenComponents';

import ZenMultiselect from '@reciprocity/multiselect';
import { JiraProject, JiraIssueType } from '@/components/jira/types';
import { ModalSize } from '@/components/zen_modal/types';
import GenericCard from '@/components/cards/GenericCard.vue';
import { getJiraProjects, getJiraProjectIssueTypes } from '@/utils/crudActions';

export default Vue.extend({
  name: 'JiraTypeSelectionCard',
  components: {
    ZenFormGroup,
    GenericCard,
    ZenMultiselect,
  },
  props: {
    objectType: {
      type: String,
      required: true,
    },
    objectId: {
      type: Number,
      required: true,
    },
    csrfToken: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      projects: <JiraProject[]>[],
      selectedProject: <JiraProject | null>null,
      issueTypes: <JiraIssueType[]>[],
      selectedIssueType: <JiraIssueType | null>null,
      loadingProjects: <boolean>false,
      loadingIssueTypes: <boolean>false,
    };
  },
  computed: {
    everythingSelected(): boolean {
      return this.selectedProject !== null && this.selectedIssueType !== null;
    },
  },
  watch: {
    async selectedProject({ id }) {
      this.selectedIssueType = null;
      try {
        this.loadingIssueTypes = true;
        const issueTypes = await this.getJiraProjectIssueTypes(id);
        this.issueTypes = issueTypes;
      } catch (error) {
        window.GGRC.Notify({
          type: 'error',
          message: error.message,
        });
      } finally {
        this.loadingIssueTypes = false;
      }
    },
  },
  async created() {
    this.$emit('updateConfig', { size: ModalSize.Small });
    try {
      this.loadingProjects = true;
      const projects = await this.getJiraProjects();
      this.projects = projects;
    } catch (error) {
      window.GGRC.Notify({
        type: 'error',
        message: error.message,
      });
    } finally {
      this.loadingProjects = false;
    }
  },
  methods: {
    openCreateModal() {
      window.GGRC.zenModal.showAndSaveState({
        type: 'NewJiraIssue',
        data: {
          fields: (this.selectedIssueType as JiraIssueType).fields,
          objectType: this.objectType,
          objectId: this.objectId,
          issueTypeId: (this.selectedIssueType as JiraIssueType).id,
          projectId: (this.selectedProject as JiraProject).id,
          csrfToken: this.csrfToken,
        },
        config: { ignoreUrl: true },
      });
    },
    getJiraProjects,
    getJiraProjectIssueTypes,
  },
});
